import { render, staticRenderFns } from "./FastLinks.vue?vue&type=template&id=6ef5a8a2&"
import script from "./FastLinks.vue?vue&type=script&lang=js&"
export * from "./FastLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports